(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [
		{name:"MWsloth_atlas_", frames: [[0,0,208,208],[0,518,176,176],[178,518,196,146],[178,666,196,146],[0,814,194,146],[436,0,70,82],[436,84,70,82],[0,696,91,72],[376,632,91,76],[376,710,87,72],[376,784,87,72],[284,814,86,72],[372,858,86,72],[196,814,86,72],[196,888,84,72],[104,210,100,112],[376,518,100,112],[0,210,102,112],[210,178,226,168],[0,348,226,168],[228,348,226,168],[210,0,224,176]]}
];


// symbols:



(lib.M_Wash_Bubble = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble_pop = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.SlothArm0001 = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.SlothArm0002 = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.SlothArm_wet0002 = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.SlothBackLeg0001 = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.SlothBackLeg0002 = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.SlothHead_001 = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.SlothHead_001_wet = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.SlothHead_002 = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.SlothHead_003 = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.SlothHead_004 = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.SlothHead_005 = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.SlothHead_006 = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.SlothHead_007 = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.SlothLeg0001 = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.SlothLeg0002 = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.SlothLeg_wet0002 = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.SlothTorso0002 = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.SlothTorso0003 = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.SlothTorso0004 = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.SlothTorso_wet = function() {
	this.spriteSheet = ss["MWsloth_atlas_"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Wet_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#91D6F7").s().p("AgeBSQgPgSgCgjQgCgiAkheQA2BhAFAgQAFAkgOARQgOARgUAAQgTAAgOgSg");
	this.shape.setTransform(4.8,10);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,9.6,20);


(lib.Tween4gfsgfs = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.Tween3sfsgsa = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.SmallStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("Ag1BSQgGgDAFgaIAHgaIgVgVQgVgUADgFQACgFAbgFIAbgFIAMgYQAOgYAEAAQAHAAAYAyIAbADQAbAEACAGQAEAJgtAlQAPAzgHAEQgHAEgvgaQgkAXgNAAIgEgBg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.7,-8.3,17.6,16.7);


(lib.LargeStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("AhGBuQgJgFAHgjIAJgiIgcgbQgbgcADgGQADgHAkgHIAjgGIARggQATghAFABQAKgBAgBDIAjAEQAkAGADAIQAFAMg7AxQAUBEgKAGQgKAFg+gjQgwAegRAAIgFAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.6,-11,23.4,22.1);


(lib.sparkle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgZAGQAYgRABg2QACA2AYANQgWAVgDArQgIgxgSgLg");
	this.shape.setTransform(-0.1,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AggAkQgLgQgMgHQANgKAKgOQAdgsADhXQAEBYAeAoQAJAMAMAHIABAAQgNALgJAQQgaApgFBFIAAABQgNhJgWgig");
	this.shape_1.setTransform(-0.1,1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgyA5QgQgZgTgMQAUgPAPgWQAthEAFiHQAGCJAvA9QAOAUASAKQgSASgOAYQgpBAgHBrQgVhwgig0gAgZAGQASALAIAxQAEgsAVgUQgYgNgCg3QgBA3gYARg");
	this.shape_2.setTransform(-0.1,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Ag0BYQA1AmAzgmQgnBAgHBqQgWh2gkg0gAhxAKQATgNAPgYQgVAlAVAlQgQgZgSgMgABRgfQAOATATALQgTARgOAYQAUglgUgigAgrhAQAnhDAEh9QAHCDAqA9QgugpguApg");
	this.shape_3.setTransform(-0.2,2);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgMC8QAQAaAOgaQgIAlgEAtQgHgugLgkgAh7ALIASgPQgMARALAMQgIgJgJgFgABvgJIANAJIgNAMQAIgMgIgJgAgJisQAIgrABg2QADA3AJAqQgLgOgKAOg");
	this.shape_4.setTransform(-0.3,1.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[]},1).wait(45));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.7,-5.7,5.2,13.3);


(lib.SlothHead_007_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Eye
	this.instance = new lib.SlothHead_007();
	this.instance.parent = this;
	this.instance.setTransform(2,2.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SlothHead_007_1, new cjs.Rectangle(-4,-4,53,47), null);


(lib.SlothHead_006_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.SlothHead_006();
	this.instance.parent = this;
	this.instance.setTransform(2,2.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SlothHead_006_1, new cjs.Rectangle(-4,-4,53,47), null);


(lib.SlothHead_005_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.SlothHead_005();
	this.instance.parent = this;
	this.instance.setTransform(2,2.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SlothHead_005_1, new cjs.Rectangle(-4,-4,53,47), null);


(lib.SlothHead_004_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.SlothHead_004();
	this.instance.parent = this;
	this.instance.setTransform(2,2.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SlothHead_004_1, new cjs.Rectangle(-4,-4,53,47), null);


(lib.SlothHead_003_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.SlothHead_003();
	this.instance.parent = this;
	this.instance.setTransform(1.8,2.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SlothHead_003_1, new cjs.Rectangle(-4,-4,53,47), null);


(lib.SlothHead_002_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.SlothHead_002();
	this.instance.parent = this;
	this.instance.setTransform(2,2.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SlothHead_002_1, new cjs.Rectangle(-4,-4,53,47), null);


(lib.SlothHead_001_wet_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.SlothHead_001_wet();
	this.instance.parent = this;
	this.instance.setTransform(2,2.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SlothHead_001_wet_1, new cjs.Rectangle(-4,-4,54,50), null);


(lib.SlothHead_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.SlothHead_001();
	this.instance.parent = this;
	this.instance.setTransform(2,2.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.SlothHead_001_1, new cjs.Rectangle(-4,-4,53.1,47), null);


(lib.sloth_tummyGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("ADdA5QgDgQgBgBQgJg3g8gwQg7gviEgjQhRgWglAJQgSBAgDAZIgRAAQgDAdAFAPQAEAQgSgKQACA0gMAPQBFBCBrAfQAqAMAgADQAsAFAugIQBTgPAQgyQAFgQgCgTg");
	this.shape.setTransform(60.9,51);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.sloth_tummyGlow, new cjs.Rectangle(36.8,32.9,48.3,36.4), null);


(lib.sloth_legGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(2,1,1).p("Ah0AUQgOAAgJAGQgIAFAFANQAFANACADQADADAEAMQAEAMAHAGQAGAFAGAAQALAAAJgHQADgCAIgKQAGAEAZAIQAZAIA5AHQA7AHAvh7QhjgfhphAQgWAQgQA0QgQAxgDAIg");
	this.shape.setTransform(-28.3,30.2);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#FFFF00").ss(4,1,1).p("ADFAgQAUAbAEAUQAIAvgIAYQgCAFgCAFQABADABAFQACAMAAADQgBANgLACQgIACgDgEQgBAEgBAFQgFATgMACQgNADgGgPQAAgEgBgDQgBAAgBABQABACAAACQADAPAAABQgBAMgKABQgVAEgRgYQgBgBgBAAQhaAOgjhOQgMgagJgrQAAgDgBgCQgDACgCABIgGAAIgJg1IgBgBIgHAGIgGAAQgBgFABgKQABgKAAgEQgBgHgCgCIgEAFIgGgBIgFgYQgCAEgEAKIgFAAQgCgQgCgHQgCgNgEAAQgGACgDgNQgBgNAAgBQgGADgBAGQgBAIgBAAQgQgDgEgNQgCgLgCgHQgBgCgCAAQAAACAAACQAAAHgCAGQgNgBgRgfQgDgBgCgCQgWgPgFgfQgDgMAAgLQgBgDgBgCQAAgCABgBQgFgVAQgRQABgCACgBQADgEAFgEQAegQAgAKQALAEAaAOQALABALACQApAHACAFIgEANQADABAtAOQAuAQAEAOQACAHgJACQAVAFAlARQAkARACAGQABAFgBgDQgBADgLAEQACACAKAFQAJAFADADQAAABgBABQAAABgBABQADABACADQAFACATANQgHAHgBABQgDABgEgBQAJAHAJALQAJANARAlQACACgGABQgDABgKgDg");
	this.shape_1.setTransform(22.5,24.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.sloth_legGlow, new cjs.Rectangle(-43.8,-2,90.9,52.4), null);


(lib.sloth_backGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("ABdCMQgigQiHgtQiIguglgVQgkgUgKgXQgJgYgKgiQgLghgWhDQBBAPATAEQA9ANAMABQAWAFByAYQABAAAAABQCFAVB3BLQB4BLAYBTQAZBTh4gcQh5gcgigPg");
	this.shape.setTransform(34.7,17.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.sloth_backGlow, new cjs.Rectangle(-2.1,-3.4,73.6,42.1), null);


(lib.M_Wash_Bubble_pop_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble_pop();
	this.instance.parent = this;
	this.instance.setTransform(-9,-9,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1.9,1,1).p("AAtACIARAAAACg9IAAAUAAgghIAJgMAg9AAIAYgBAgmgrIANAPAgrArIALgNAgEAwIAAAOAAdAoIAKAN");
	this.shape.setTransform(11.2,10.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_pop_1, new cjs.Rectangle(-9,-9,44,44), null);


(lib.M_Wash_Bubble_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble();
	this.instance.parent = this;
	this.instance.setTransform(-13,-13,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_1, new cjs.Rectangle(-13,-13,52,52), null);


(lib.invisiblebox = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0)").s().p("AhwDIIhZgEIAEmHIBOgEIDvAAIBSABIgCGKIhGAEg");
	this.shape.setTransform(-0.3,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.invisiblebox, new cjs.Rectangle(-20.5,-20,40.4,40), null);


(lib.blueglowtummy = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("ADdA5QgDgQgBgBQgJg3g8gwQg7gviEgjQhRgWglAJQgSBAgDAZIgRAAQgDAdAFAPQAEAQgSgKQACA0gMAPQBFBCBrAfQAqAMAgADQAsAFAugIQBTgPAQgyQAFgQgCgTg");
	this.shape.setTransform(60.9,51);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowtummy, new cjs.Rectangle(36.8,32.9,48.3,36.4), null);


(lib.blueglowlegs = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(2,1,1).p("Ah0AUQgOAAgJAGQgIAFAFANQAFANACADQADADAEAMQAEAMAHAGQAGAFAGAAQALAAAJgHQADgCAIgKQAGAEAZAIQAZAIA5AHQA7AHAvh7QhjgfhphAQgWAQgQA0QgQAxgDAIg");
	this.shape.setTransform(-28.3,30.2);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#0099FF").ss(4,1,1).p("ADFAgQAUAbAEAUQAIAvgIAYQgCAFgCAFQABADABAFQACAMAAADQgBANgLACQgIACgDgEQgBAEgBAFQgFATgMACQgNADgGgPQAAgEgBgDQgBAAgBABQABACAAACQADAPAAABQgBAMgKABQgVAEgRgYQgBgBgBAAQhaAOgjhOQgMgagJgrQAAgDgBgCQgDACgCABIgGAAIgJg1IgBgBIgHAGIgGAAQgBgFABgKQABgKAAgEQgBgHgCgCIgEAFIgGgBIgFgYQgCAEgEAKIgFAAQgCgQgCgHQgCgNgEAAQgGACgDgNQgBgNAAgBQgGADgBAGQgBAIgBAAQgQgDgEgNQgCgLgCgHQgBgCgCAAQAAACAAACQAAAHgCAGQgNgBgRgfQgDgBgCgCQgWgPgFgfQgDgMAAgLQgBgDgBgCQAAgCABgBQgFgVAQgRQABgCACgBQADgEAFgEQAegQAgAKQALAEAaAOQALABALACQApAHACAFIgEANQADABAtAOQAuAQAEAOQACAHgJACQAVAFAlARQAkARACAGQABAFgBgDQgBADgLAEQACACAKAFQAJAFADADQAAABgBABQAAABgBABQADABACADQAFACATANQgHAHgBABQgDABgEgBQAJAHAJALQAJANARAlQACACgGABQgDABgKgDg");
	this.shape_1.setTransform(22.5,24.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowlegs, new cjs.Rectangle(-43.8,-2,90.9,52.4), null);


(lib.blueglowback = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("ABdCMQgigQiHgtQiIguglgVQgkgUgKgXQgJgYgKgiQgLghgWhDQBBAPATAEQA9ANAMABQAWAFByAYQABAAAAABQCFAVB3BLQB4BLAYBTQAZBTh4gcQh5gcgigPg");
	this.shape.setTransform(34.7,17.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowback, new cjs.Rectangle(-2.1,-3.4,73.6,42.1), null);


(lib.SlothTorso_wet_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"final":0,final_loop:1});

	// Layer 4
	this.instance = new lib.SlothTorso_wet();
	this.instance.parent = this;
	this.instance.setTransform(-5,-3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5,-3,112,88);


(lib.SlothLeg_wet = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"final":0,"final_loop":1});

	// Layer 6
	this.instance = new lib.SlothLeg_wet0002();
	this.instance.parent = this;
	this.instance.setTransform(-3.8,-4.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-3.8,-4.7,51,56);


(lib.SlothArm_wet = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"final":0,"final_loop":1});

	// Layer 7
	this.instance = new lib.SlothArm_wet0002();
	this.instance.parent = this;
	this.instance.setTransform(-14.2,-5.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-16,-5.2,98.8,73);


(lib.star_2_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.SmallStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,-4.2,-0.7,-6.2,-1.6,-9.1,-2.8,-9.1,-4.5,-9.1,-6.3,-6,-7.7,-4.2,-8.6,0.7,-10,5.6,-11.4,7.5,-12.3,10.6,-13.8,10.6,-15.6,10.6,-17.5,7.3,-18.9,5.3,-19.8,0.1,-21.1,-5.1,-22.4,-7,-23.2,-10.3,-24.5,-10.3,-26.3,-10.3,-28,-7.2,-29.3,-5.7,-30,-1.7,-31.1], orient:'auto'},alpha:0.102},16).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.1,-4.7,10.5,10);


(lib.star_1_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.LargeStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,4.5,-0.7,6.5,-1.6,9.4,-2.8,9.4,-4.5,9.4,-6.3,6.3,-7.7,4.5,-8.6,-0.4,-10,-5.3,-11.4,-7.2,-12.3,-10.3,-13.8,-10.3,-15.6,-10.3,-17.5,-7,-18.9,-5,-19.8,0.1,-21.1,5.4,-22.4,7.3,-23.2,10.6,-24.5,10.6,-26.3,10.6,-28,7.5,-29.3,6,-30,2,-31.1], orient:'auto'},alpha:0.102},13).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.9,-6.4,14,13.3);


(lib.sparkle2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_2_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle2, new cjs.Rectangle(-5.2,-4.7,10.6,10), null);


(lib.sparkle1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_1_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle1, new cjs.Rectangle(-6.9,-6.4,14,13.3), null);


(lib.Running_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Wet_drop();
	this.instance.parent = this;
	this.instance.setTransform(4.8,10,1,1,0,0,0,4.8,10);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);
	new cjs.ButtonHelper(this.instance, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:146.2},15).to({regX:4.5,scaleX:0.1,scaleY:0.1,y:182.5},4).to({_off:true},1).wait(5));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10,-10,37,48);


(lib.left_over_bubbles_sparse = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(59.6,9,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_sparse, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_few = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(42.3,6.2,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(43.3,4.3,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(39.9,6.5,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(54,11,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_few, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(45.6,4.1,0.326,0.326,-155.4,0,0,11.3,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_2, new cjs.Rectangle(27.1,-14.9,46.8,40.7), null);


(lib.left_over_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(70.8,4,0.404,0.404,4.9,0,0,11.1,10.3);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(64.4,1.4,0.289,0.289,4.9,0,0,11.1,10.3);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(31,4.8,0.289,0.289,4.9,0,0,11.1,10);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(29.7,12.7,0.431,0.431,4.9,0,0,11.3,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(34.6,7,0.253,0.253,160.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(47.2,-5.1,0.267,0.267,-155.4,0,0,11.5,11.1);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(20.1,12.2,0.221,0.221,-155.4,0,0,11.3,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(20.2,17,0.162,0.162,-155.3,0,0,11.2,11.1);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(82.6,4.9,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles, new cjs.Rectangle(5.3,-21.9,91.8,57.3), null);


(lib.Bubbles_together = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// M_Wash_Bubble
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(30.1,18.9,0.303,0.303,-155.3,0,0,11,10.9);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_pop_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(30.2,18.9,0.757,0.757,-155.3,0,0,10.9,11);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},38).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:10.9,regY:11,scaleX:0.76,scaleY:0.76,x:30.2},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(24.5,20.9,0.313,0.313,-155.3,0,0,11.1,11.1);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_pop_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(24.6,20.9,0.757,0.757,-155.3,0,0,11,11);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_2}]},40).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:24.6},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(39.6,16.1,0.287,0.287,-155.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_pop_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(39.6,16.1,0.757,0.757,-155.3,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4}]}).to({state:[{t:this.instance_4}]},34).to({state:[{t:this.instance_5}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(9.9,-2.5,0.199,0.199,-155.3,0,0,11,10.7);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_pop_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(9.8,-2.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_7}]},32).to({state:[{t:this.instance_7}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:9.8},32).wait(60));

	// M_Wash_Bubble
	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(25.7,-1.5,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_pop_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(25.6,-1.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8}]}).to({state:[{t:this.instance_9}]},36).to({state:[{t:this.instance_9}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:25.6},36).wait(56));

	// M_Wash_Bubble
	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(22.2,6,0.108,0.108,-155.3,0,0,11.1,11.8);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_pop_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(22,6,0.757,0.757,-155.3,0,0,11.2,10.9);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10}]}).to({state:[{t:this.instance_11}]},30).to({state:[{t:this.instance_11}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({_off:true,regX:11.2,regY:10.9,scaleX:0.76,scaleY:0.76,x:22},30).wait(62));

	// M_Wash_Bubble
	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(29.2,-9,0.119,0.119,-155.3,0,0,11.5,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_13 = new lib.M_Wash_Bubble_pop_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(29.1,-9,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_13.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12}]}).to({state:[{t:this.instance_13}]},32).to({state:[{t:this.instance_13}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true,regX:11.1,scaleX:0.76,scaleY:0.76,x:29.1},32).wait(60));

	// M_Wash_Bubble
	this.instance_14 = new lib.M_Wash_Bubble_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(42.2,-3.1,0.271,0.271,-155.3,0,0,10.3,11.3);
	this.instance_14.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_15 = new lib.M_Wash_Bubble_pop_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(42.2,-3.1,0.757,0.757,-155.3,0,0,11,11.1);
	this.instance_15.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14}]}).to({state:[{t:this.instance_15}]},30).to({state:[{t:this.instance_15}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({_off:true,regX:11,regY:11.1,scaleX:0.76,scaleY:0.76},30).wait(62));

	// M_Wash_Bubble
	this.instance_16 = new lib.M_Wash_Bubble_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(48.3,9,0.125,0.125,-155.3,0,0,11,10.5);
	this.instance_16.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({regY:11,scaleX:0.76,scaleY:0.76,x:48.4,y:8.9},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_17 = new lib.M_Wash_Bubble_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(32.6,-16.6,0.076,0.076,-155.3,0,0,10.8,11);
	this.instance_17.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,y:-16.7},20).wait(2).to({_off:true},2).wait(68));

	// M_Wash_Bubble
	this.instance_18 = new lib.M_Wash_Bubble_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(35.5,5.1,0.103,0.103,-155.3,0,0,10.3,10.8);
	this.instance_18.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,x:32.6,y:7.6},22).wait(2).to({regY:11,x:35.5,y:5.1},0).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_19 = new lib.M_Wash_Bubble_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(56,0.3,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_19.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_20 = new lib.M_Wash_Bubble_pop_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(52,-4.5,0.686,0.686,-155.4,0,0,10.3,11.2);
	this.instance_20.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_19}]}).to({state:[{t:this.instance_19}]},24).to({state:[{t:this.instance_20}]},2).to({state:[]},2).wait(64));
	this.timeline.addTween(cjs.Tween.get(this.instance_19).to({regX:10.3,scaleX:0.69,scaleY:0.69,rotation:-155.4,x:52,y:-4.5},24).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_21 = new lib.M_Wash_Bubble_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(52.4,20,0.067,0.067,-155.3,0,0,11.8,11.1);
	this.instance_21.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_22 = new lib.M_Wash_Bubble_pop_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(52.4,19.8,0.757,0.757,-155.3,0,0,11.2,11.2);
	this.instance_22.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_21}]}).to({state:[{t:this.instance_21}]},22).to({state:[{t:this.instance_22}]},8).to({state:[{t:this.instance_22}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({regX:11.7,regY:11.2,scaleX:0.53,scaleY:0.53,rotation:-155.4,x:46.9,y:21.6},22).to({_off:true,regX:11.2,scaleX:0.76,scaleY:0.76,rotation:-155.3,x:52.4,y:19.8},8).wait(62));

	// M_Wash_Bubble
	this.instance_23 = new lib.M_Wash_Bubble_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(38.5,-8.5,0.4,0.4,0,0,0,11,11);
	this.instance_23.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_24 = new lib.M_Wash_Bubble_pop_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(38.5,-8.5,1,1,0,0,0,11,11);
	this.instance_24.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_23}]}).to({state:[{t:this.instance_23}]},38).to({state:[{t:this.instance_24}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance_23).to({scaleX:1,scaleY:1},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_25 = new lib.M_Wash_Bubble_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(44,-14,0.413,0.413,0,0,0,11,11);
	this.instance_25.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_26 = new lib.M_Wash_Bubble_pop_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(44,-14,1,1,0,0,0,11,11);
	this.instance_26.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_25}]}).to({state:[{t:this.instance_25}]},40).to({state:[{t:this.instance_26}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_25).to({scaleX:1,scaleY:1},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_27 = new lib.M_Wash_Bubble_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(28.7,0,0.379,0.379,0,0,0,11,11);
	this.instance_27.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_28 = new lib.M_Wash_Bubble_pop_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(28.7,0,1,1,0,0,0,11,11);
	this.instance_28.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27}]}).to({state:[{t:this.instance_27}]},34).to({state:[{t:this.instance_28}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_27).to({scaleX:1,scaleY:1},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_29 = new lib.M_Wash_Bubble_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(74.5,6,0.263,0.263,0,0,0,11,11);
	this.instance_29.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_30 = new lib.M_Wash_Bubble_pop_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(74.5,6,1,1,0,0,0,11,11);
	this.instance_30.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_29}]}).to({state:[{t:this.instance_30}]},32).to({state:[{t:this.instance_30}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).to({_off:true,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_31 = new lib.M_Wash_Bubble_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(54.9,13.5,0.214,0.214,0,0,0,11,11.2);
	this.instance_31.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_32 = new lib.M_Wash_Bubble_pop_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(54.9,13.5,1,1,0,0,0,11,11);
	this.instance_32.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_31}]}).to({state:[{t:this.instance_32}]},36).to({state:[{t:this.instance_32}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).to({_off:true,regY:11,scaleX:1,scaleY:1},36).wait(56));

	// M_Wash_Bubble
	this.instance_33 = new lib.M_Wash_Bubble_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(55,2.5,0.143,0.143,0,0,0,10.8,11.2);
	this.instance_33.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_34 = new lib.M_Wash_Bubble_pop_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(55,2.5,1,1,0,0,0,11,11);
	this.instance_34.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_33}]}).to({state:[{t:this.instance_34}]},30).to({state:[{t:this.instance_34}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_33).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_35 = new lib.M_Wash_Bubble_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(54.9,24.5,0.157,0.157,0,0,0,11.2,11.2);
	this.instance_35.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_36 = new lib.M_Wash_Bubble_pop_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(54.9,24.5,1,1,0,0,0,11,11);
	this.instance_36.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_35}]}).to({state:[{t:this.instance_36}]},32).to({state:[{t:this.instance_36}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_35).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_37 = new lib.M_Wash_Bubble_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(36,24.5,0.357,0.357,0,0,0,10.2,11.1);
	this.instance_37.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_38 = new lib.M_Wash_Bubble_pop_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(36,24.5,1,1,0,0,0,11,11);
	this.instance_38.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_37}]}).to({state:[{t:this.instance_38}]},30).to({state:[{t:this.instance_38}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_37).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_39 = new lib.M_Wash_Bubble_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(22,13.5,0.165,0.165,0,0,0,10.9,11);
	this.instance_39.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).to({regY:10.9,scaleX:0.91,scaleY:0.91,x:18.6,y:13.3},22).to({regX:11,regY:11,scaleX:1,scaleY:1,x:22,y:13.5},2).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_40 = new lib.M_Wash_Bubble_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(39.7,11,0.136,0.136,0,0,0,11.1,11.1);
	this.instance_40.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).to({regX:11,regY:11,scaleX:1,scaleY:1},22).wait(2).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_41 = new lib.M_Wash_Bubble_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(17.7,28,0.164,0.164,0,0,0,10.7,11);
	this.instance_41.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_41).to({regX:11,scaleX:1,scaleY:1},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_42 = new lib.M_Wash_Bubble_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(11,2.5,0.088,0.088,0,0,0,10.8,10.8);
	this.instance_42.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_43 = new lib.M_Wash_Bubble_pop_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(11,2.5,1,1,0,0,0,11,11);
	this.instance_43.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_42}]}).to({state:[{t:this.instance_43}]},30).to({state:[{t:this.instance_43}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_42).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.2,-37.9,114.4,94.8);


(lib.SlothTorso_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{wash:0,wash_stop:70});

	// sloth_tummyMud_001
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(46.1,53.2,0.344,0.541,0,25.5,-138.2,35.6,10.8);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(57.8,58.4,0.344,0.541,0,25.5,-138.2,35.7,10.9);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(65.7,62.1,0.51,0.355,0,76.7,-87,35.5,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},69).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.SlothLeg_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":70});

	// Layer 2
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-31.3,21.4,0.381,0.387,0,-104.2,-103,36.1,10.9);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(17.3,12.5,0.381,0.387,0,-131.7,-130.5,35.8,10.8);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(24.6,25.6,0.381,0.387,0,-131.7,-130.5,35.8,10.8);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(30.4,37.7,0.347,0.367,0,173.4,176,35.5,10.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},69).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.SlothLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{dirty:0,dirty_stop:1,clean:2,clean_loop:3,glow:4,glow_loop:5,"wash":6,"wash_stop":64,glowclean:65,glowclean_loop:66,"final":67,"final_loop":68});

	// Layer 6
	this.instance = new lib.SlothLeg0001();
	this.instance.parent = this;
	this.instance.setTransform(-4,-4.7,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(20.5,20.2,0.5,0.5,60,0,0,50.6,5.2);

	this.instance_2 = new lib.SlothLeg0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-4,-4.7,0.5,0.5);

	this.instance_3 = new lib.sloth_legGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-1.7,20.7,0.899,0.899,10.3,0,0,1.7,23.9);

	this.instance_4 = new lib.left_over_bubbles_sparse();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-33.3,20.3,0.5,0.5,45,0,0,47.5,10.2);

	this.glow = new lib.blueglowlegs();
	this.glow.parent = this;
	this.glow.setTransform(-1.7,20.7,0.899,0.899,10.3,0,0,1.7,23.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance_4}]},8).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance_4}]},50).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance_4},{t:this.glow}]},1).to({state:[{t:this.instance_2}]},2).to({state:[]},2).wait(137));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-4,-4.7,50,56);


(lib.SlothBackLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"final":156,"final_loop":157});

	// Layer 6
	this.instance = new lib.SlothBackLeg0001();
	this.instance.parent = this;
	this.instance.setTransform(-4.2,-2.2,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(9.8,26.2,0.5,0.5,45,0,0,47.5,10.2);

	this.instance_2 = new lib.SlothBackLeg0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-4.2,-2.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},8).to({state:[{t:this.instance_2}]},142).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-16.7,-9.6,52.8,48.4);


(lib.SlothArm = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":109,"glowclean":110,"glowclean_loop":111,"final":112,"final_loop":113});

	// Layer 9
	this.instance = new lib.SlothArm0001();
	this.instance.parent = this;
	this.instance.setTransform(-14.2,-5.5,0.5,0.5);

	this.instance_1 = new lib.SlothArm0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-14.2,-5.5,0.5,0.5);

	this.instance_2 = new lib.sloth_backGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(65.6,6.9,0.9,0.9,6.2,0,0,34.8,17.5);

	this.glow = new lib.blueglowback();
	this.glow.parent = this;
	this.glow.setTransform(65.6,6.9,0.9,0.9,6.2,0,0,34.8,17.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1}]},103).to({state:[{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(47));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-16,-8.7,105.1,76.3);


(lib.water_drops_016 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.Running_drop();
	this.instance.parent = this;
	this.instance.setTransform(185.8,-3.5,0.486,0.486,0,0,180,4.8,10.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({_off:true},24).wait(8));

	// Layer 1
	this.instance_1 = new lib.Running_drop();
	this.instance_1.parent = this;
	this.instance_1.setTransform(117.9,-21.9,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(7).to({_off:false},0).to({_off:true},24).wait(2));

	// WET DROPS
	this.instance_2 = new lib.Running_drop();
	this.instance_2.parent = this;
	this.instance_2.setTransform(70,-32.6,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(4).to({_off:false},0).to({_off:true},24).wait(5));

	// WET DROPS
	this.instance_3 = new lib.Running_drop();
	this.instance_3.parent = this;
	this.instance_3.setTransform(150.9,-21.9,0.486,0.486,0,0,180,4.7,10.1);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1).to({_off:false},0).to({_off:true},24).wait(8));

	// WET DROPS
	this.instance_4 = new lib.Running_drop();
	this.instance_4.parent = this;
	this.instance_4.setTransform(85.9,-3.5,0.486,0.486,0,0,0,4.7,10.1);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(6).to({_off:false},0).to({_off:true},24).wait(3));

	// WET DROPS
	this.instance_5 = new lib.Running_drop();
	this.instance_5.parent = this;
	this.instance_5.setTransform(237,42.7,0.486,0.486,0,0,0,4.7,10.1);
	this.instance_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(3).to({_off:false},0).to({_off:true},24).wait(6));

	// WET DROPS
	this.instance_6 = new lib.Running_drop();
	this.instance_6.parent = this;
	this.instance_6.setTransform(132.4,4.6,0.486,0.486,0,0,0,4.8,10.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true},24).wait(9));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(125.1,-5.3,18,23);


(lib.slotharm2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"clean":1,"glow":2,"wash":3});

	// Layer 1
	this.instance = new lib.SlothArm("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(74.5,13.4,0.942,0.942,-13.9,0,0,64.7,4.4);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,106.1,88.9);


(lib.sloth_tummyMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,dirty_loop:1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":71,"glowclean":72,"glowclean_loop":73,"final":74,"final_loop":75});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#835136").s().p("AiwBfIgIgYQgJALgMAAIgCgBQAOgbARgbQAFgHADgIQARgOAWgGQAXgDAYgFIgBAAIAHgGIAZgQIAGAAIABgBQAYgMAbgBIAKgGQAXgIARgPQAXgUAjAAIAEABIAEgBQAfgHAfgKIABAAIAEADIAJABIAJgDQgEACgHABIAAACQAAAggBAIQgDANgJAKQADACAAAFQAAAJgIAAQgGAAgCgFIAAgDIgJAEIABAIQACgFAGAAQAIACAAAIQAAALgJAAQgEAAgCgCIACATQAAAMgDAFQgFANgTAAQgHAAgEgEQgHARgJANQgRAagWAAQgGAAgFgCIgDgCQgFAJgGAIQgMAQgOAAQgNAAgJgFIAAAAQgCADgEAAQgFAAgCgGIgBgEIABgEIgDgEIgEAGQgIALgHAAQgJAAgHgNIgEgLIgBAIQgEARgNAAQgYAAgSgSIgGgGIgHAMQgJASgMAAQgPAAgMgYgAgFgtIAAAAIACAAgAC7h2IABAAIAAAAg");
	this.shape.setTransform(23.9,22.2);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(169,114,78,0.902)").s().p("ABRAOIgBgEQAAgKAJABQAIABAAAIQAAAEgDADQgDADgDAAQgGAAgBgGgAhegBIgCgIQAAgLAMABQAMACAAALQABAMgMAAQgHAAgEgHg");
	this.shape_1.setTransform(13.1,33.1);

	this.instance = new lib.left_over_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(25.4,25.6,0.167,0.293,-173.3,0,0,50.5,5.2);

	this.instance_1 = new lib.left_over_bubbles_few();
	this.instance_1.parent = this;
	this.instance_1.setTransform(17.6,30.2,0.315,0.572,0,0,0,47.8,9.3);

	this.instance_2 = new lib.sloth_tummyGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(27.4,29.6,1,1,0,167.2,-12.8,60.9,50.9);

	this.glow = new lib.blueglowtummy();
	this.glow.parent = this;
	this.glow.setTransform(27.4,29.6,1,1,0,167.2,-12.8,60.9,50.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).to({state:[{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape_1},{t:this.shape},{t:this.instance_2}]},2).to({state:[]},2).to({state:[{t:this.instance_1},{t:this.instance}]},8).to({state:[{t:this.instance_1},{t:this.instance}]},57).to({state:[{t:this.instance_1},{t:this.instance},{t:this.glow}]},1).to({state:[]},2).to({state:[]},152).wait(78));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(3.1,10.3,41.7,24.7);


(lib.sloth_backMud_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":90});

	// Layer 9
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(23.2,17.9,0.538,0.538,0,174.9,174.8,35.6,10.9);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-23,-10.3,0.376,0.376,0,-132.1,-132.2,35.7,11);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(3.9,2.4,0.376,0.376,0,-132.1,-132.2,35.4,10.9);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-5.6,4.7,0.376,0.376,0,-132.1,-132.2,35.5,11);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-12.8,-5.5,0.376,0.376,0,-132.1,-132.2,35.6,11.1);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(11.3,5.8,0.538,0.538,0,-132.1,-132.2,35.5,11);

	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-3.5,8.4,0.538,0.538,0,-132.1,-132.2,35.6,11);

	this.instance_7 = new lib.Bubbles_together();
	this.instance_7.parent = this;
	this.instance_7.setTransform(22.8,22.3,0.538,0.538,0,-43.1,-43.2,35.8,11);

	this.instance_8 = new lib.Bubbles_together();
	this.instance_8.parent = this;
	this.instance_8.setTransform(32.4,25.3,0.538,0.538,0,-132.1,-132.2,35.6,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},89).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.sloth_backMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":220,"final":222,"final_loop":223});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#835136").s().p("AEYBRIgGABQgSADgXgDQgjgFgJgXQgIACgWgCQgVgCgKgDIgBAAQgYATgoAAQgrAAgUgRIgGgIQgWAugmAAQg9gMgQgLIgNAPQgPALgYAAQgWAAgOgXQgHgMgDgOIgSADQg2glgUgYQgaggAAgnIABgEIAbgDQAQgDARgBQASgEARABIAlABQAfgBAdAHQAgAGAhgDIAEACQAkgEAkACQAPgBANAEQAkAIAjAKQAvATAzAHQAhAGAdANQAjAQAeAWQAaAUAeAQIACAFIABAEQACAIAAAHQAAAKgGAHQgIAKgRAAQgdAAgUgUg");
	this.shape.setTransform(-4.6,8.2);

	this.instance = new lib.left_over_bubbles_2();
	this.instance.parent = this;
	this.instance.setTransform(-21.9,4.1,0.406,0.406,0,0,0,48.9,4.8);

	this.instance_1 = new lib.left_over_bubbles_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-16.2,3.6,0.618,0.618,0,0,0,50.6,5.2);

	this.instance_2 = new lib.left_over_bubbles_sparse("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(8.3,6.1,0.599,0.599,15,0,0,35.6,10.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape}]},2).to({state:[]},2).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},8).to({state:[]},207).to({state:[]},1).wait(80));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-40.5,-1.9,71.9,20.2);


(lib.SlothTorso = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0});

	// Layer 6
	this.tummymud = new lib.sloth_tummyMud_001();
	this.tummymud.parent = this;
	this.tummymud.setTransform(53.5,59.5,1,1,-114.8,0,0,23.1,17.5);

	this.backmud = new lib.sloth_backMud_001();
	this.backmud.parent = this;
	this.backmud.setTransform(63.2,25.5,1,1,23.2,0,0,-4.5,7.4);

	this.instance = new lib.SlothTorso0002();
	this.instance.parent = this;
	this.instance.setTransform(-5,-3.5,0.5,0.5);

	this.instance_1 = new lib.SlothTorso0003();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-5,-3.5,0.5,0.5);

	this.instance_2 = new lib.SlothTorso0004();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-5,-3.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.backmud},{t:this.tummymud}]}).to({state:[{t:this.instance}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5,-3.5,113,99.8);


(lib.Sloth = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{rest:0,rest_stop:76,animalSound:78,wrongAnswer:86,wet:130,wet_stop:154,"clean":156,excited:216,excited_stop:259});

	// timeline functions:
	this.frame_77 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_84 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_128 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_154 = function() {
		/* stop();*/
	}
	this.frame_214 = function() {
		/* stop();*/
	}
	this.frame_259 = function() {
		/* 
		
		gameObjects._game.done();
		
		stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(77).call(this.frame_77).wait(7).call(this.frame_84).wait(44).call(this.frame_128).wait(26).call(this.frame_154).wait(60).call(this.frame_214).wait(45).call(this.frame_259).wait(79));

	// Layer 3
	this.instance = new lib.water_drops_016();
	this.instance.parent = this;
	this.instance.setTransform(269.8,228.4,0.6,0.6,0,0,0,92.4,49.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(130).to({_off:false},0).to({_off:true},24).wait(184));

	// sparkle
	this.instance_1 = new lib.sparkle();
	this.instance_1.parent = this;
	this.instance_1.setTransform(300,174.4,0.679,0.679,-5.2);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(253).to({_off:false},0).to({_off:true},8).wait(77));

	// sparkle
	this.instance_2 = new lib.sparkle();
	this.instance_2.parent = this;
	this.instance_2.setTransform(284.8,214.2,0.539,0.539,-5.2);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(245).to({_off:false},0).to({_off:true},16).wait(77));

	// Sloth Tummy
	this.tummy_bubbles = new lib.SlothTorso_bubbles();
	this.tummy_bubbles.parent = this;
	this.tummy_bubbles.setTransform(320.9,213.5,1.089,1.089,-9.2,0,0,75.2,51.2);

	this.timeline.addTween(cjs.Tween.get(this.tummy_bubbles).wait(86).to({_off:true},44).wait(208));

	// Sloth Leg
	this.legs_bubbles = new lib.SlothLeg_bubbles();
	this.legs_bubbles.parent = this;
	this.legs_bubbles.setTransform(338.6,214.1,1.089,1.089,-9.9,0,0,5.4,4.8);

	this.timeline.addTween(cjs.Tween.get(this.legs_bubbles).wait(86).to({_off:true},44).wait(208));

	// Sloth Torso
	this.back_bubbles = new lib.sloth_backMud_001_bubbles();
	this.back_bubbles.parent = this;
	this.back_bubbles.setTransform(301.1,180.5);

	this.timeline.addTween(cjs.Tween.get(this.back_bubbles).wait(86).to({_off:true},44).wait(208));

	// sparkle
	this.instance_3 = new lib.sparkle();
	this.instance_3.parent = this;
	this.instance_3.setTransform(359.1,226.2,0.606,0.606);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(238).to({_off:false},0).to({_off:true},23).wait(77));

	// sparkle
	this.instance_4 = new lib.sparkle();
	this.instance_4.parent = this;
	this.instance_4.setTransform(235.8,242.2,0.444,0.444,-5.2);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(230).to({_off:false},0).to({_off:true},31).wait(77));

	// Sloth Head_004
	this.instance_5 = new lib.SlothHead_001_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(251.9,184.7,1.254,1.254,0,-20.9,159.1,21,18.1);

	this.instance_6 = new lib.SlothHead_002_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(253.6,182.4,1.253,1.253,0,-19.3,160.7,20.8,18.2);
	this.instance_6._off = true;

	this.instance_7 = new lib.SlothHead_003_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(254.6,179.8,1.253,1.253,0,-17.8,162.2,21.1,17.9);
	this.instance_7._off = true;

	this.instance_8 = new lib.SlothHead_004_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(256.4,177.5,1.253,1.253,0,-16.3,163.7,20.8,18);
	this.instance_8._off = true;

	this.instance_9 = new lib.SlothHead_005_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(257.8,175,1.253,1.253,0,-14.6,165.4,20.8,17.9);
	this.instance_9._off = true;

	this.instance_10 = new lib.SlothHead_006_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(259.2,172.9,1.253,1.253,0,-13.1,166.9,20.8,18.1);
	this.instance_10._off = true;

	this.instance_11 = new lib.SlothHead_007_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(260.5,170.5,1.254,1.254,0,-11.7,168.3,20.9,18);

	this.instance_12 = new lib.SlothHead_001_wet_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(251.9,184.7,1.254,1.254,0,-20.9,159.1,21,18.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5}]}).to({state:[{t:this.instance_6}]},18).to({state:[{t:this.instance_7}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_11,p:{regX:20.9,regY:18,skewX:-11.7,skewY:168.3,x:260.5,y:170.5}}]},2).to({state:[{t:this.instance_10}]},26).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_7}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_5}]},14).to({state:[{t:this.instance_5}]},8).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_7}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_11,p:{regX:21,regY:18.1,skewX:-11.4,skewY:168.6,x:251.9,y:184.7}}]},2).to({state:[{t:this.instance_10}]},14).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_7}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_12}]},8).to({state:[{t:this.instance_5}]},24).to({state:[{t:this.instance_5}]},62).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_7}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_11,p:{regX:21,regY:18.1,skewX:-15.7,skewY:164.3,x:255.8,y:172.8}}]},2).to({state:[]},33).wait(77));
	this.timeline.addTween(cjs.Tween.get(this.instance_5).to({_off:true},18).wait(46).to({_off:false},0).wait(22).to({_off:true},2).wait(34).to({_off:false},0).to({_off:true},8).wait(24).to({_off:false},0).wait(62).to({_off:true},2).wait(120));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(18).to({_off:false},0).to({_off:true},2).wait(42).to({_off:false},0).to({_off:true},2).wait(24).to({_off:false,regX:20.9,regY:18.1,x:252,y:184.8},0).to({_off:true},2).wait(30).to({_off:false},0).to({_off:true},2).wait(96).to({_off:false,skewX:-20,skewY:160,x:252.6,y:182.7},0).to({_off:true},2).wait(118));
	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(20).to({_off:false},0).to({_off:true},2).wait(38).to({_off:false},0).to({_off:true},2).wait(28).to({_off:false,regX:20.9,regY:18.4,skewX:-17.6,skewY:162.4,x:252.1,y:185.1},0).to({_off:true},2).wait(26).to({_off:false},0).to({_off:true},2).wait(100).to({_off:false,regX:21,regY:18.1,skewX:-19.1,skewY:160.9,x:253.2,y:180.8},0).to({_off:true},2).wait(116));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(22).to({_off:false},0).to({_off:true},2).wait(34).to({_off:false},0).to({_off:true},2).wait(32).to({_off:false,regX:21.4,regY:18.1,skewX:-16.1,skewY:163.9,x:251.3,y:184.9},0).to({_off:true},2).wait(22).to({_off:false},0).to({_off:true},2).wait(104).to({_off:false,regX:20.9,regY:17.9,skewX:-18.3,skewY:161.7,x:253.9,y:178.6},0).to({_off:true},2).wait(114));
	this.timeline.addTween(cjs.Tween.get(this.instance_9).wait(24).to({_off:false},0).to({_off:true},2).wait(30).to({_off:false},0).to({_off:true},2).wait(36).to({_off:false,regX:21.1,regY:18,skewX:-14.5,skewY:165.5,x:251.6,y:184.7},0).to({_off:true},2).wait(18).to({_off:false},0).to({_off:true},2).wait(108).to({_off:false,regX:21,regY:18.1,skewX:-17.3,skewY:162.7,x:254.5,y:176.8},0).to({_off:true},2).wait(112));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(26).to({_off:false},0).to({_off:true},2).wait(26).to({_off:false},0).to({_off:true},2).wait(40).to({_off:false,regX:21.2,regY:18,skewX:-12.8,skewY:167.2,x:251.6,y:184.7},0).to({_off:true},2).wait(14).to({_off:false},0).to({_off:true},2).wait(112).to({_off:false,regX:20.9,regY:18.1,skewX:-16.5,skewY:163.5,x:255.2,y:174.8},0).to({_off:true},2).wait(110));

	// Sloth Arm
	this.sloth_arm = new lib.SlothArm();
	this.sloth_arm.parent = this;
	this.sloth_arm.setTransform(306,188.3,1.5,1.279,0.2,0,0,67.8,2.6);

	this.sloth_arm_1 = new lib.SlothArm_wet();
	this.sloth_arm_1.parent = this;
	this.sloth_arm_1.setTransform(306,188.3,1.5,1.279,0.2,0,0,67.8,2.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.sloth_arm}]}).to({state:[{t:this.sloth_arm}]},18).to({state:[{t:this.sloth_arm}]},2).to({state:[{t:this.sloth_arm}]},2).to({state:[{t:this.sloth_arm}]},2).to({state:[{t:this.sloth_arm}]},2).to({state:[{t:this.sloth_arm}]},2).to({state:[{t:this.sloth_arm}]},26).to({state:[{t:this.sloth_arm}]},2).to({state:[{t:this.sloth_arm}]},2).to({state:[{t:this.sloth_arm}]},2).to({state:[{t:this.sloth_arm}]},2).to({state:[{t:this.sloth_arm}]},2).to({state:[{t:this.sloth_arm}]},14).to({state:[{t:this.sloth_arm}]},8).to({state:[{t:this.sloth_arm_1}]},44).to({state:[{t:this.sloth_arm}]},24).to({state:[{t:this.sloth_arm}]},62).to({state:[{t:this.sloth_arm}]},2).to({state:[{t:this.sloth_arm}]},2).to({state:[{t:this.sloth_arm}]},2).to({state:[{t:this.sloth_arm}]},2).to({state:[{t:this.sloth_arm}]},2).to({state:[{t:this.sloth_arm}]},2).to({state:[]},33).wait(77));
	this.timeline.addTween(cjs.Tween.get(this.sloth_arm).wait(18).to({rotation:0,x:306.9,y:187.3},0).wait(2).to({regX:67.9,x:307.8,y:186.2},0).wait(2).to({regX:67.8,regY:7.9,x:308.5,y:191.8},0).wait(2).to({regY:2.6,x:309.3,y:183.9},0).wait(2).to({x:310.2,y:182.8},0).wait(2).to({x:310.9,y:181.7},0).wait(26).to({x:310.2,y:182.8},0).wait(2).to({x:309.3,y:183.9},0).wait(2).to({regY:7.9,x:308.5,y:191.8},0).wait(2).to({regX:67.9,regY:2.6,x:307.8,y:186.2},0).wait(2).to({regX:67.8,x:306.9,y:187.3},0).wait(2).to({rotation:0.2,x:306,y:188.3},0).wait(22).to({_off:true},44).wait(24).to({_off:false},0).wait(64).to({regX:66.8,regY:2.7,rotation:-1,x:305.8,y:187.7},0).wait(2).to({regX:67.8,regY:2.6,rotation:-2.3,x:308.6,y:186.7},0).wait(2).to({regX:68.9,regY:2.8,rotation:-3.5,x:311.5,y:186.1},0).wait(2).to({regX:67.9,regY:3.6,rotation:-4.8,x:311.4,y:186.5},0).wait(2).to({regX:67.8,regY:2.6,rotation:-6.3,x:312.4,y:184.5},0).wait(2).to({regY:2.1,rotation:-7.6,x:313.7,y:183.6},0).to({_off:true},33).wait(77));

	// Sloth Leg
	this.sloth_frontleg = new lib.SlothLeg();
	this.sloth_frontleg.parent = this;
	this.sloth_frontleg.setTransform(338.6,214.1,1.089,1.089,-9.9,0,0,5.4,4.8);

	this.sloth_frontleg_1 = new lib.SlothLeg_wet();
	this.sloth_frontleg_1.parent = this;
	this.sloth_frontleg_1.setTransform(338.6,214.1,1.089,1.089,-9.9,0,0,5.4,4.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.sloth_frontleg}]}).to({state:[{t:this.sloth_frontleg}]},18).to({state:[{t:this.sloth_frontleg}]},2).to({state:[{t:this.sloth_frontleg}]},2).to({state:[{t:this.sloth_frontleg}]},2).to({state:[{t:this.sloth_frontleg}]},2).to({state:[{t:this.sloth_frontleg}]},2).to({state:[{t:this.sloth_frontleg}]},26).to({state:[{t:this.sloth_frontleg}]},2).to({state:[{t:this.sloth_frontleg}]},2).to({state:[{t:this.sloth_frontleg}]},2).to({state:[{t:this.sloth_frontleg}]},2).to({state:[{t:this.sloth_frontleg}]},2).to({state:[{t:this.sloth_frontleg}]},14).to({state:[{t:this.sloth_frontleg}]},8).to({state:[{t:this.sloth_frontleg_1}]},44).to({state:[{t:this.sloth_frontleg}]},24).to({state:[{t:this.sloth_frontleg}]},62).to({state:[{t:this.sloth_frontleg}]},2).to({state:[{t:this.sloth_frontleg}]},2).to({state:[{t:this.sloth_frontleg}]},2).to({state:[{t:this.sloth_frontleg}]},2).to({state:[{t:this.sloth_frontleg}]},2).to({state:[{t:this.sloth_frontleg}]},2).to({state:[]},33).wait(77));
	this.timeline.addTween(cjs.Tween.get(this.sloth_frontleg).wait(18).to({regY:4.5,rotation:-8.3,x:338.5,y:212.9},0).wait(2).to({rotation:-6.5,y:212.1},0).wait(2).to({regX:5.2,regY:4.4,rotation:-4.8,x:338.1,y:211.3},0).wait(2).to({regY:4.5,rotation:-3.3,x:338.2,y:210.5},0).wait(2).to({regX:5.7,rotation:-1.5,x:338.6,y:209.6},0).wait(2).to({regX:5.5,rotation:0,x:338.2,y:208.9},0).wait(26).to({regX:5.7,rotation:-1.5,x:338.6,y:209.6},0).wait(2).to({regX:5.2,rotation:-3.3,x:338.2,y:210.5},0).wait(2).to({regY:4.4,rotation:-4.8,x:338.1,y:211.3},0).wait(2).to({regX:5.4,regY:4.5,rotation:-6.5,x:338.5,y:212.1},0).wait(2).to({rotation:-8.3,y:212.9},0).wait(2).to({regY:4.8,rotation:-9.9,x:338.6,y:214.1},0).wait(22).to({_off:true},44).wait(24).to({_off:false},0).wait(64).to({regX:5.3,regY:4.6,scaleX:1.09,scaleY:1.09,rotation:0,skewX:-9,skewY:-9.8,x:339.2,y:213.8},0).wait(2).to({regX:5.4,regY:4.8,scaleX:1.1,scaleY:1.09,skewX:-8,x:340.1,y:214.1},0).wait(2).to({scaleX:1.1,scaleY:1.08,skewX:-7.3,x:340.7},0).wait(2).to({regX:4.2,regY:4.7,scaleX:1.1,scaleY:1.08,skewX:-6.3,x:340},0).wait(2).to({regX:5,regY:4.5,scaleX:1.1,scaleY:1.08,skewX:-5.3,x:341.6,y:213.8},0).wait(2).to({regX:5.4,regY:4.8,scaleX:1.11,scaleY:1.08,skewX:-4.6,x:342.8,y:214.1},0).to({_off:true},33).wait(77));

	// Sloth Torso
	this.sloth_torso = new lib.SlothTorso();
	this.sloth_torso.parent = this;
	this.sloth_torso.setTransform(320.9,213.5,1.089,1.089,-9.2,0,0,75.2,51.2);

	this.sloth_torso_1 = new lib.SlothTorso_wet_1();
	this.sloth_torso_1.parent = this;
	this.sloth_torso_1.setTransform(320.9,213.5,1.089,1.089,-9.2,0,0,75.2,51.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.sloth_torso}]}).to({state:[{t:this.sloth_torso}]},18).to({state:[{t:this.sloth_torso}]},2).to({state:[{t:this.sloth_torso}]},2).to({state:[{t:this.sloth_torso}]},2).to({state:[{t:this.sloth_torso}]},2).to({state:[{t:this.sloth_torso}]},2).to({state:[{t:this.sloth_torso}]},26).to({state:[{t:this.sloth_torso}]},2).to({state:[{t:this.sloth_torso}]},2).to({state:[{t:this.sloth_torso}]},2).to({state:[{t:this.sloth_torso}]},2).to({state:[{t:this.sloth_torso}]},2).to({state:[{t:this.sloth_torso}]},14).to({state:[{t:this.sloth_torso}]},8).to({state:[{t:this.sloth_torso_1}]},44).to({state:[{t:this.sloth_torso}]},24).to({state:[{t:this.sloth_torso}]},62).to({state:[{t:this.sloth_torso}]},2).to({state:[{t:this.sloth_torso}]},2).to({state:[{t:this.sloth_torso}]},2).to({state:[{t:this.sloth_torso}]},2).to({state:[{t:this.sloth_torso}]},2).to({state:[{t:this.sloth_torso}]},2).to({state:[]},33).wait(77));
	this.timeline.addTween(cjs.Tween.get(this.sloth_torso).wait(18).to({regX:75.7,regY:51,rotation:-7.6,x:321.9,y:212.6},0).wait(2).to({regX:75.3,rotation:-6,y:212.1},0).wait(2).to({regX:75.1,rotation:-4.5,x:322.2,y:211.6},0).wait(2).to({regY:50.9,rotation:-3,x:322.7,y:210.9},0).wait(2).to({regY:51,rotation:-1.5,x:323.2,y:210.5},0).wait(2).to({regX:75,regY:50.9,rotation:0,x:323.7,y:209.8},0).wait(26).to({regX:75.1,regY:51,rotation:-1.5,x:323.2,y:210.5},0).wait(2).to({regY:50.9,rotation:-3,x:322.7,y:210.9},0).wait(2).to({regY:51,rotation:-4.5,x:322.2,y:211.6},0).wait(2).to({regX:75.3,rotation:-6,x:321.9,y:212.1},0).wait(2).to({regX:75.7,rotation:-7.6,y:212.6},0).wait(2).to({regX:75.2,regY:51.2,rotation:-9.2,x:320.9,y:213.5},0).wait(22).to({_off:true},44).wait(24).to({_off:false},0).wait(64).to({rotation:-8,x:321.7,y:213.1},0).wait(2).to({rotation:-6.8,x:322.5,y:212.6},0).wait(2).to({rotation:-5.5,x:323.3,y:212.3},0).wait(2).to({regX:75.8,regY:51.1,rotation:-4.3,x:324.7,y:211.6},0).wait(2).to({regX:75.2,regY:51.2,rotation:-3.1,x:324.8,y:211.4},0).wait(2).to({regX:75.3,rotation:-2,x:325.6,y:211},0).to({_off:true},33).wait(77));

	// Sloth Arm
	this.sloth_arm_2 = new lib.slotharm2();
	this.sloth_arm_2.parent = this;
	this.sloth_arm_2.setTransform(261.1,218.6,1,1,0,0,0,53.1,44.5);

	this.timeline.addTween(cjs.Tween.get(this.sloth_arm_2).wait(18).to({regX:64.6,regY:4.5,scaleX:0.94,scaleY:0.94,rotation:-6.6,x:283.6,y:188.1},0).wait(2).to({regX:64.8,rotation:0.3,x:284.9,y:188.7},0).wait(2).to({regY:4.1,scaleX:0.94,scaleY:0.94,rotation:7.5,x:286.1,y:189},0).wait(2).to({regX:64.2,regY:4.7,rotation:14.8,x:286.4,y:189.9},0).wait(2).to({regX:64.9,regY:4.5,rotation:21.8,x:288.4,y:190.5},0).wait(2).to({regX:64.8,scaleX:0.94,scaleY:0.94,rotation:29.1,x:289.3,y:190.9},0).wait(26).to({regX:64.9,scaleX:0.94,scaleY:0.94,rotation:21.8,x:288.4,y:190.5},0).wait(2).to({regX:64.2,regY:4.7,rotation:14.8,x:286.4,y:189.9},0).wait(2).to({regX:64.8,regY:4.1,rotation:7.5,x:286.1,y:189},0).wait(2).to({regY:4.5,scaleX:0.94,scaleY:0.94,rotation:0.3,x:284.9,y:188.7},0).wait(2).to({regX:64.6,rotation:-6.6,x:283.6,y:188.1},0).wait(2).to({regX:64.7,regY:4.4,rotation:-13.9,x:282.5,y:187.4},0).wait(154).to({regX:64.5,regY:4.1,scaleX:0.94,scaleY:0.94,rotation:-15.1,x:283.5,y:186.1},0).wait(2).to({regX:64.6,regY:4.3,rotation:-16.3,x:285.1,y:185.1},0).wait(2).to({regX:64.9,regY:4.1,rotation:-17.6,x:286.5,y:183.6},0).wait(2).to({regX:64,regY:4.2,rotation:-19,x:287.2,y:182.7},0).wait(2).to({regX:64.5,regY:4,rotation:-20.3,x:288.8,y:181.2},0).wait(2).to({regY:4.2,scaleX:0.94,scaleY:0.94,rotation:-21.6,x:290.4,y:180.2},0).to({_off:true},33).wait(77));

	// Sloth Back Leg
	this.sloth_hindleg = new lib.SlothBackLeg();
	this.sloth_hindleg.parent = this;
	this.sloth_hindleg.setTransform(316.9,218.2,1.089,1.089,6.2,0,0,20.5,5.1);

	this.timeline.addTween(cjs.Tween.get(this.sloth_hindleg).wait(18).to({regX:20.6,rotation:5.1,x:317.1,y:217.9},0).wait(2).to({regX:20.2,rotation:4,x:316.8,y:217.4},0).wait(2).to({regX:20.6,regY:5.2,rotation:3,x:317.5,y:217.2},0).wait(2).to({regX:20.5,regY:5,rotation:2,y:216.5},0).wait(2).to({regX:20.7,regY:5.2,rotation:1,x:317.9,y:216.3},0).wait(2).to({regX:20.5,regY:5.1,rotation:0,x:317.8,y:215.8},0).wait(26).to({regX:20.7,regY:5.2,rotation:1,x:317.9,y:216.3},0).wait(2).to({regX:20.5,regY:5,rotation:2,x:317.5,y:216.5},0).wait(2).to({regX:20.6,regY:5.2,rotation:3,y:217.2},0).wait(2).to({regX:20.2,regY:5.1,rotation:4,x:316.8,y:217.4},0).wait(2).to({regX:20.6,rotation:5.1,x:317.1,y:217.9},0).wait(2).to({regX:20.5,rotation:6.2,x:316.9,y:218.2},0).wait(154).to({regX:20.4,scaleX:1.09,scaleY:1.09,rotation:0,skewX:7,skewY:6.3,x:317.3,y:218.3},0).wait(2).to({regX:20.5,regY:4,scaleX:1.09,scaleY:1.09,skewX:8,x:318.1,y:217.1},0).wait(2).to({regX:20.6,regY:5,scaleX:1.08,scaleY:1.1,skewX:8.8,x:318.5,y:218.3},0).wait(2).to({regX:20.5,regY:5.1,scaleX:1.08,scaleY:1.1,skewX:9.8,x:318.9,y:218.4},0).wait(2).to({regX:20.4,regY:5.4,scaleX:1.08,scaleY:1.1,skewX:10.5,x:319.3,y:218.7},0).wait(2).to({regX:19.9,scaleX:1.08,scaleY:1.11,skewX:11.5,x:320,y:218.5},0).to({_off:true},33).wait(77));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(182.6,148.9,208.3,122.5);


(lib.sloth = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// tummyGlow
	this.tummyGlow = new lib.sloth_tummyGlow();
	this.tummyGlow.parent = this;
	this.tummyGlow.setTransform(280.5,174.3,1,1,0,0,0,42.8,34.6);
	this.tummyGlow.alpha = 0;
	this.tummyGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.tummyGlow.cache(35,31,52,40);

	this.timeline.addTween(cjs.Tween.get(this.tummyGlow).wait(1));

	// backGlow
	this.backGlow = new lib.sloth_backGlow();
	this.backGlow.parent = this;
	this.backGlow.setTransform(285.2,162.9,1,1,0,0,0,34.7,19.4);
	this.backGlow.alpha = 0;
	this.backGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.backGlow.cache(-4,-5,78,46);

	this.timeline.addTween(cjs.Tween.get(this.backGlow).wait(1));

	// legGlow
	this.legGlow = new lib.sloth_legGlow();
	this.legGlow.parent = this;
	this.legGlow.setTransform(335.5,201.8,1,1,0,0,0,22.5,24.2);
	this.legGlow.alpha = 0;
	this.legGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.legGlow.cache(-46,-4,95,56);

	this.timeline.addTween(cjs.Tween.get(this.legGlow).wait(1));

	// Layer 20
	this.leg3 = new lib.invisiblebox();
	this.leg3.parent = this;
	this.leg3.setTransform(282.4,213.9,0.611,0.434,25.8);

	this.leg1 = new lib.invisiblebox();
	this.leg1.parent = this;
	this.leg1.setTransform(227.5,206.2,1.637,0.712,-16.6);

	this.leg2 = new lib.invisiblebox();
	this.leg2.parent = this;
	this.leg2.setTransform(338.4,201.1,1.42,0.712,57.4);

	this.tummy = new lib.invisiblebox();
	this.tummy.parent = this;
	this.tummy.setTransform(297.3,196,0.993,0.391,23.9);

	this.back = new lib.invisiblebox();
	this.back.parent = this;
	this.back.setTransform(284.1,158.8,1.714,0.59,18.7);

	this.mouth = new lib.invisiblebox();
	this.mouth.parent = this;
	this.mouth.setTransform(211.4,157.1,0.49,0.549);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.mouth},{t:this.back},{t:this.tummy},{t:this.leg2},{t:this.leg1},{t:this.leg3}]}).wait(1));

	// main
	this.main = new lib.Sloth();
	this.main.parent = this;
	this.main.setTransform(1.7,26,1,1,0,0,0,20.5,55.3);

	this.timeline.addTween(cjs.Tween.get(this.main).wait(1));

}).prototype = getMCSymbolPrototype(lib.sloth, new cjs.Rectangle(163.8,119.6,208.4,122.5), null);


// stage content:
(lib.MWsloth = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"rest":0,"animalSound":78,"wrongAnswer":86,"wet":130,"clean":156,"excited":216});

	// timeline functions:
	this.frame_77 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_84 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_128 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_154 = function() {
		/* stop();*/
	}
	this.frame_214 = function() {
		/* stop();*/
	}
	this.frame_230 = function() {
		playSound("GleamAfterDrying5wav");
	}
	this.frame_259 = function() {
		/* 
		
		gameObjects._game.done();
		
		stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(77).call(this.frame_77).wait(7).call(this.frame_84).wait(44).call(this.frame_128).wait(26).call(this.frame_154).wait(60).call(this.frame_214).wait(16).call(this.frame_230).wait(29).call(this.frame_259).wait(2));

	// Layer 3
	this.instance_13 = new lib.water_drops_016();
	this.instance_13.parent = this;
	this.instance_13.setTransform(269.8,228.4,0.6,0.6,0,0,0,92.4,49.1);
	this.instance_13._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_13).wait(130).to({_off:false},0).to({_off:true},24).wait(107));

	// sparkle
	this.instance_14 = new lib.sparkle();
	this.instance_14.parent = this;
	this.instance_14.setTransform(300,174.4,0.679,0.679,-5.2);
	this.instance_14._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_14).wait(253).to({_off:false},0).wait(8));

	// sparkle
	this.instance_15 = new lib.sparkle();
	this.instance_15.parent = this;
	this.instance_15.setTransform(284.8,214.2,0.539,0.539,-5.2);
	this.instance_15._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_15).wait(245).to({_off:false},0).wait(16));

	// Sloth Leg
	this.instance_16 = new lib.SlothLeg_bubbles();
	this.instance_16.parent = this;
	this.instance_16.setTransform(338.6,214.1,1.089,1.089,-9.9,0,0,5.4,4.8);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).wait(86).to({_off:true},44).wait(131));

	// Sloth Torso
	this.instance_17 = new lib.SlothTorso_bubbles();
	this.instance_17.parent = this;
	this.instance_17.setTransform(320.9,213.5,1.089,1.089,-9.2,0,0,75.2,51.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).wait(86).to({_off:true},44).wait(131));

	// sparkle
	this.instance_18 = new lib.sparkle();
	this.instance_18.parent = this;
	this.instance_18.setTransform(359.1,226.2,0.606,0.606);
	this.instance_18._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_18).wait(238).to({_off:false},0).wait(23));

	// sparkle
	this.instance_19 = new lib.sparkle();
	this.instance_19.parent = this;
	this.instance_19.setTransform(235.8,242.2,0.444,0.444,-5.2);
	this.instance_19._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_19).wait(230).to({_off:false},0).wait(31));

	// game stuff
	this.instance_20 = new lib.Tween4gfsgfs();
	this.instance_20.parent = this;
	this.instance_20.setTransform(98.4,123.5);
	this.instance_20._off = true;

	this.instance_21 = new lib.Tween3sfsgsa();
	this.instance_21.parent = this;
	this.instance_21.setTransform(98.4,123.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_20}]},18).to({state:[{t:this.instance_20}]},2).to({state:[{t:this.instance_20}]},2).to({state:[{t:this.instance_20}]},2).to({state:[{t:this.instance_20}]},2).to({state:[{t:this.instance_21}]},2).to({state:[{t:this.instance_20}]},26).to({state:[{t:this.instance_20}]},2).to({state:[{t:this.instance_20}]},2).to({state:[{t:this.instance_20}]},2).to({state:[{t:this.instance_20}]},2).to({state:[]},2).wait(197));
	this.timeline.addTween(cjs.Tween.get(this.instance_20).wait(18).to({_off:false},0).wait(8).to({_off:true},2).wait(26).to({_off:false},0).wait(8).to({_off:true},2).wait(197));

	// Sloth Head_004
	this.instance_22 = new lib.SlothHead_001_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(251.9,184.7,1.254,1.254,0,-20.9,159.1,21,18.1);

	this.instance_23 = new lib.SlothHead_002_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(253.6,182.4,1.253,1.253,0,-19.3,160.7,20.8,18.2);
	this.instance_23._off = true;

	this.instance_24 = new lib.SlothHead_003_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(254.6,179.8,1.253,1.253,0,-17.8,162.2,21.1,17.9);
	this.instance_24._off = true;

	this.instance_25 = new lib.SlothHead_004_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(256.4,177.5,1.253,1.253,0,-16.3,163.7,20.8,18);
	this.instance_25._off = true;

	this.instance_26 = new lib.SlothHead_005_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(257.8,175,1.253,1.253,0,-14.6,165.4,20.8,17.9);
	this.instance_26._off = true;

	this.instance_27 = new lib.SlothHead_006_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(259.2,172.9,1.253,1.253,0,-13.1,166.9,20.8,18.1);
	this.instance_27._off = true;

	this.instance_28 = new lib.SlothHead_007_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(260.5,170.5,1.254,1.254,0,-11.7,168.3,20.9,18);

	this.instance_29 = new lib.SlothHead_001_wet_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(251.9,184.7,1.254,1.254,0,-20.9,159.1,21,18.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_22}]}).to({state:[{t:this.instance_23}]},18).to({state:[{t:this.instance_24}]},2).to({state:[{t:this.instance_25}]},2).to({state:[{t:this.instance_26}]},2).to({state:[{t:this.instance_27}]},2).to({state:[{t:this.instance_28,p:{regX:20.9,regY:18,skewX:-11.7,skewY:168.3,x:260.5,y:170.5}}]},2).to({state:[{t:this.instance_27}]},26).to({state:[{t:this.instance_26}]},2).to({state:[{t:this.instance_25}]},2).to({state:[{t:this.instance_24}]},2).to({state:[{t:this.instance_23}]},2).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_22}]},14).to({state:[{t:this.instance_22}]},8).to({state:[{t:this.instance_23}]},2).to({state:[{t:this.instance_24}]},2).to({state:[{t:this.instance_25}]},2).to({state:[{t:this.instance_26}]},2).to({state:[{t:this.instance_27}]},2).to({state:[{t:this.instance_28,p:{regX:21,regY:18.1,skewX:-11.4,skewY:168.6,x:251.9,y:184.7}}]},2).to({state:[{t:this.instance_27}]},14).to({state:[{t:this.instance_26}]},2).to({state:[{t:this.instance_25}]},2).to({state:[{t:this.instance_24}]},2).to({state:[{t:this.instance_23}]},2).to({state:[{t:this.instance_22}]},2).to({state:[{t:this.instance_29}]},8).to({state:[{t:this.instance_22}]},24).to({state:[{t:this.instance_22}]},62).to({state:[{t:this.instance_23}]},2).to({state:[{t:this.instance_24}]},2).to({state:[{t:this.instance_25}]},2).to({state:[{t:this.instance_26}]},2).to({state:[{t:this.instance_27}]},2).to({state:[{t:this.instance_28,p:{regX:21,regY:18.1,skewX:-15.7,skewY:164.3,x:255.8,y:172.8}}]},2).wait(33));
	this.timeline.addTween(cjs.Tween.get(this.instance_22).to({_off:true},18).wait(46).to({_off:false},0).wait(22).to({_off:true},2).wait(34).to({_off:false},0).to({_off:true},8).wait(24).to({_off:false},0).wait(62).to({_off:true},2).wait(43));
	this.timeline.addTween(cjs.Tween.get(this.instance_23).wait(18).to({_off:false},0).to({_off:true},2).wait(42).to({_off:false},0).to({_off:true},2).wait(24).to({_off:false,regX:20.9,regY:18.1,x:252,y:184.8},0).to({_off:true},2).wait(30).to({_off:false},0).to({_off:true},2).wait(96).to({_off:false,skewX:-20,skewY:160,x:252.6,y:182.7},0).to({_off:true},2).wait(41));
	this.timeline.addTween(cjs.Tween.get(this.instance_24).wait(20).to({_off:false},0).to({_off:true},2).wait(38).to({_off:false},0).to({_off:true},2).wait(28).to({_off:false,regX:20.9,regY:18.4,skewX:-17.6,skewY:162.4,x:252.1,y:185.1},0).to({_off:true},2).wait(26).to({_off:false},0).to({_off:true},2).wait(100).to({_off:false,regX:21,regY:18.1,skewX:-19.1,skewY:160.9,x:253.2,y:180.8},0).to({_off:true},2).wait(39));
	this.timeline.addTween(cjs.Tween.get(this.instance_25).wait(22).to({_off:false},0).to({_off:true},2).wait(34).to({_off:false},0).to({_off:true},2).wait(32).to({_off:false,regX:21.4,regY:18.1,skewX:-16.1,skewY:163.9,x:251.3,y:184.9},0).to({_off:true},2).wait(22).to({_off:false},0).to({_off:true},2).wait(104).to({_off:false,regX:20.9,regY:17.9,skewX:-18.3,skewY:161.7,x:253.9,y:178.6},0).to({_off:true},2).wait(37));
	this.timeline.addTween(cjs.Tween.get(this.instance_26).wait(24).to({_off:false},0).to({_off:true},2).wait(30).to({_off:false},0).to({_off:true},2).wait(36).to({_off:false,regX:21.1,regY:18,skewX:-14.5,skewY:165.5,x:251.6,y:184.7},0).to({_off:true},2).wait(18).to({_off:false},0).to({_off:true},2).wait(108).to({_off:false,regX:21,regY:18.1,skewX:-17.3,skewY:162.7,x:254.5,y:176.8},0).to({_off:true},2).wait(35));
	this.timeline.addTween(cjs.Tween.get(this.instance_27).wait(26).to({_off:false},0).to({_off:true},2).wait(26).to({_off:false},0).to({_off:true},2).wait(40).to({_off:false,regX:21.2,regY:18,skewX:-12.8,skewY:167.2,x:251.6,y:184.7},0).to({_off:true},2).wait(14).to({_off:false},0).to({_off:true},2).wait(112).to({_off:false,regX:20.9,regY:18.1,skewX:-16.5,skewY:163.5,x:255.2,y:174.8},0).to({_off:true},2).wait(33));

	// Sloth Arm
	this.instance_30 = new lib.SlothArm();
	this.instance_30.parent = this;
	this.instance_30.setTransform(306,188.3,1.5,1.279,0.2,0,0,67.8,2.6);

	this.instance_31 = new lib.SlothArm_wet();
	this.instance_31.parent = this;
	this.instance_31.setTransform(306,188.3,1.5,1.279,0.2,0,0,67.8,2.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_30}]}).to({state:[{t:this.instance_30}]},18).to({state:[{t:this.instance_30}]},2).to({state:[{t:this.instance_30}]},2).to({state:[{t:this.instance_30}]},2).to({state:[{t:this.instance_30}]},2).to({state:[{t:this.instance_30}]},2).to({state:[{t:this.instance_30}]},26).to({state:[{t:this.instance_30}]},2).to({state:[{t:this.instance_30}]},2).to({state:[{t:this.instance_30}]},2).to({state:[{t:this.instance_30}]},2).to({state:[{t:this.instance_30}]},2).to({state:[{t:this.instance_30}]},14).to({state:[{t:this.instance_30}]},8).to({state:[{t:this.instance_31}]},44).to({state:[{t:this.instance_30}]},24).to({state:[{t:this.instance_30}]},62).to({state:[{t:this.instance_30}]},2).to({state:[{t:this.instance_30}]},2).to({state:[{t:this.instance_30}]},2).to({state:[{t:this.instance_30}]},2).to({state:[{t:this.instance_30}]},2).to({state:[{t:this.instance_30}]},2).wait(33));
	this.timeline.addTween(cjs.Tween.get(this.instance_30).wait(18).to({rotation:0,x:306.9,y:187.3},0).wait(2).to({regX:67.9,x:307.8,y:186.2},0).wait(2).to({regX:67.8,regY:7.9,x:308.5,y:191.8},0).wait(2).to({regY:2.6,x:309.3,y:183.9},0).wait(2).to({x:310.2,y:182.8},0).wait(2).to({x:310.9,y:181.7},0).wait(26).to({x:310.2,y:182.8},0).wait(2).to({x:309.3,y:183.9},0).wait(2).to({regY:7.9,x:308.5,y:191.8},0).wait(2).to({regX:67.9,regY:2.6,x:307.8,y:186.2},0).wait(2).to({regX:67.8,x:306.9,y:187.3},0).wait(2).to({rotation:0.2,x:306,y:188.3},0).wait(22).to({_off:true},44).wait(24).to({_off:false},0).wait(64).to({regX:66.8,regY:2.7,rotation:-1,x:305.8,y:187.7},0).wait(2).to({regX:67.8,regY:2.6,rotation:-2.3,x:308.6,y:186.7},0).wait(2).to({regX:68.9,regY:2.8,rotation:-3.5,x:311.5,y:186.1},0).wait(2).to({regX:67.9,regY:3.6,rotation:-4.8,x:311.4,y:186.5},0).wait(2).to({regX:67.8,regY:2.6,rotation:-6.3,x:312.4,y:184.5},0).wait(2).to({regY:2.1,rotation:-7.6,x:313.7,y:183.6},0).wait(33));

	// Sloth Leg
	this.instance_32 = new lib.SlothLeg();
	this.instance_32.parent = this;
	this.instance_32.setTransform(338.6,214.1,1.089,1.089,-9.9,0,0,5.4,4.8);

	this.instance_33 = new lib.SlothLeg_wet();
	this.instance_33.parent = this;
	this.instance_33.setTransform(338.6,214.1,1.089,1.089,-9.9,0,0,5.4,4.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_32}]}).to({state:[{t:this.instance_32}]},18).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},26).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},14).to({state:[{t:this.instance_32}]},8).to({state:[{t:this.instance_33}]},44).to({state:[{t:this.instance_32}]},24).to({state:[{t:this.instance_32}]},62).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).to({state:[{t:this.instance_32}]},2).wait(33));
	this.timeline.addTween(cjs.Tween.get(this.instance_32).wait(18).to({regY:4.5,rotation:-8.3,x:338.5,y:212.9},0).wait(2).to({rotation:-6.5,y:212.1},0).wait(2).to({regX:5.2,regY:4.4,rotation:-4.8,x:338.1,y:211.3},0).wait(2).to({regY:4.5,rotation:-3.3,x:338.2,y:210.5},0).wait(2).to({regX:5.7,rotation:-1.5,x:338.6,y:209.6},0).wait(2).to({regX:5.5,rotation:0,x:338.2,y:208.9},0).wait(26).to({regX:5.7,rotation:-1.5,x:338.6,y:209.6},0).wait(2).to({regX:5.2,rotation:-3.3,x:338.2,y:210.5},0).wait(2).to({regY:4.4,rotation:-4.8,x:338.1,y:211.3},0).wait(2).to({regX:5.4,regY:4.5,rotation:-6.5,x:338.5,y:212.1},0).wait(2).to({rotation:-8.3,y:212.9},0).wait(2).to({regY:4.8,rotation:-9.9,x:338.6,y:214.1},0).wait(22).to({_off:true},44).wait(24).to({_off:false},0).wait(64).to({regX:5.3,regY:4.6,scaleX:1.09,scaleY:1.09,rotation:0,skewX:-9,skewY:-9.8,x:339.2,y:213.8},0).wait(2).to({regX:5.4,regY:4.8,scaleX:1.1,scaleY:1.09,skewX:-8,x:340.1,y:214.1},0).wait(2).to({scaleX:1.1,scaleY:1.08,skewX:-7.3,x:340.7},0).wait(2).to({regX:4.2,regY:4.7,scaleX:1.1,scaleY:1.08,skewX:-6.3,x:340},0).wait(2).to({regX:5,regY:4.5,scaleX:1.1,scaleY:1.08,skewX:-5.3,x:341.6,y:213.8},0).wait(2).to({regX:5.4,regY:4.8,scaleX:1.11,scaleY:1.08,skewX:-4.6,x:342.8,y:214.1},0).wait(33));

	// Sloth Torso
	this.instance_34 = new lib.SlothTorso();
	this.instance_34.parent = this;
	this.instance_34.setTransform(320.9,213.5,1.089,1.089,-9.2,0,0,75.2,51.2);

	this.instance_35 = new lib.SlothTorso_wet_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(320.9,213.5,1.089,1.089,-9.2,0,0,75.2,51.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_34}]}).to({state:[{t:this.instance_34}]},18).to({state:[{t:this.instance_34}]},2).to({state:[{t:this.instance_34}]},2).to({state:[{t:this.instance_34}]},2).to({state:[{t:this.instance_34}]},2).to({state:[{t:this.instance_34}]},2).to({state:[{t:this.instance_34}]},26).to({state:[{t:this.instance_34}]},2).to({state:[{t:this.instance_34}]},2).to({state:[{t:this.instance_34}]},2).to({state:[{t:this.instance_34}]},2).to({state:[{t:this.instance_34}]},2).to({state:[{t:this.instance_34}]},14).to({state:[{t:this.instance_34}]},8).to({state:[{t:this.instance_35}]},44).to({state:[{t:this.instance_34}]},24).to({state:[{t:this.instance_34}]},62).to({state:[{t:this.instance_34}]},2).to({state:[{t:this.instance_34}]},2).to({state:[{t:this.instance_34}]},2).to({state:[{t:this.instance_34}]},2).to({state:[{t:this.instance_34}]},2).to({state:[{t:this.instance_34}]},2).wait(33));
	this.timeline.addTween(cjs.Tween.get(this.instance_34).wait(18).to({regX:75.7,regY:51,rotation:-7.6,x:321.9,y:212.6},0).wait(2).to({regX:75.3,rotation:-6,y:212.1},0).wait(2).to({regX:75.1,rotation:-4.5,x:322.2,y:211.6},0).wait(2).to({regY:50.9,rotation:-3,x:322.7,y:210.9},0).wait(2).to({regY:51,rotation:-1.5,x:323.2,y:210.5},0).wait(2).to({regX:75,regY:50.9,rotation:0,x:323.7,y:209.8},0).wait(26).to({regX:75.1,regY:51,rotation:-1.5,x:323.2,y:210.5},0).wait(2).to({regY:50.9,rotation:-3,x:322.7,y:210.9},0).wait(2).to({regY:51,rotation:-4.5,x:322.2,y:211.6},0).wait(2).to({regX:75.3,rotation:-6,x:321.9,y:212.1},0).wait(2).to({regX:75.7,rotation:-7.6,y:212.6},0).wait(2).to({regX:75.2,regY:51.2,rotation:-9.2,x:320.9,y:213.5},0).wait(22).to({_off:true},44).wait(24).to({_off:false},0).wait(64).to({rotation:-8,x:321.7,y:213.1},0).wait(2).to({rotation:-6.8,x:322.5,y:212.6},0).wait(2).to({rotation:-5.5,x:323.3,y:212.3},0).wait(2).to({regX:75.8,regY:51.1,rotation:-4.3,x:324.7,y:211.6},0).wait(2).to({regX:75.2,regY:51.2,rotation:-3.1,x:324.8,y:211.4},0).wait(2).to({regX:75.3,rotation:-2,x:325.6,y:211},0).wait(33));

	// Sloth Arm
	this.instance_36 = new lib.SlothArm();
	this.instance_36.parent = this;
	this.instance_36.setTransform(282.5,187.4,0.942,0.942,-13.9,0,0,64.7,4.4);

	this.timeline.addTween(cjs.Tween.get(this.instance_36).wait(18).to({regX:64.6,regY:4.5,rotation:-6.6,x:283.6,y:188.1},0).wait(2).to({regX:64.8,rotation:0.3,x:284.9,y:188.7},0).wait(2).to({regY:4.1,scaleX:0.94,scaleY:0.94,rotation:7.5,x:286.1,y:189},0).wait(2).to({regX:64.2,regY:4.7,rotation:14.8,x:286.4,y:189.9},0).wait(2).to({regX:64.9,regY:4.5,rotation:21.8,x:288.4,y:190.5},0).wait(2).to({regX:64.8,scaleX:0.94,scaleY:0.94,rotation:29.1,x:289.3,y:190.9},0).wait(26).to({regX:64.9,scaleX:0.94,scaleY:0.94,rotation:21.8,x:288.4,y:190.5},0).wait(2).to({regX:64.2,regY:4.7,rotation:14.8,x:286.4,y:189.9},0).wait(2).to({regX:64.8,regY:4.1,rotation:7.5,x:286.1,y:189},0).wait(2).to({regY:4.5,scaleX:0.94,scaleY:0.94,rotation:0.3,x:284.9,y:188.7},0).wait(2).to({regX:64.6,rotation:-6.6,x:283.6,y:188.1},0).wait(2).to({regX:64.7,regY:4.4,rotation:-13.9,x:282.5,y:187.4},0).wait(154).to({regX:64.5,regY:4.1,scaleX:0.94,scaleY:0.94,rotation:-15.1,x:283.5,y:186.1},0).wait(2).to({regX:64.6,regY:4.3,rotation:-16.3,x:285.1,y:185.1},0).wait(2).to({regX:64.9,regY:4.1,rotation:-17.6,x:286.5,y:183.6},0).wait(2).to({regX:64,regY:4.2,rotation:-19,x:287.2,y:182.7},0).wait(2).to({regX:64.5,regY:4,rotation:-20.3,x:288.8,y:181.2},0).wait(2).to({regY:4.2,scaleX:0.94,scaleY:0.94,rotation:-21.6,x:290.4,y:180.2},0).wait(33));

	// Sloth Back Leg
	this.instance_37 = new lib.SlothBackLeg();
	this.instance_37.parent = this;
	this.instance_37.setTransform(316.9,218.2,1.089,1.089,6.2,0,0,20.5,5.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_37).wait(18).to({regX:20.6,rotation:5.1,x:317.1,y:217.9},0).wait(2).to({regX:20.2,rotation:4,x:316.8,y:217.4},0).wait(2).to({regX:20.6,regY:5.2,rotation:3,x:317.5,y:217.2},0).wait(2).to({regX:20.5,regY:5,rotation:2,y:216.5},0).wait(2).to({regX:20.7,regY:5.2,rotation:1,x:317.9,y:216.3},0).wait(2).to({regX:20.5,regY:5.1,rotation:0,x:317.8,y:215.8},0).wait(26).to({regX:20.7,regY:5.2,rotation:1,x:317.9,y:216.3},0).wait(2).to({regX:20.5,regY:5,rotation:2,x:317.5,y:216.5},0).wait(2).to({regX:20.6,regY:5.2,rotation:3,y:217.2},0).wait(2).to({regX:20.2,regY:5.1,rotation:4,x:316.8,y:217.4},0).wait(2).to({regX:20.6,rotation:5.1,x:317.1,y:217.9},0).wait(2).to({regX:20.5,rotation:6.2,x:316.9,y:218.2},0).wait(154).to({regX:20.4,scaleX:1.09,scaleY:1.09,rotation:0,skewX:7,skewY:6.3,x:317.3,y:218.3},0).wait(2).to({regX:20.5,regY:4,scaleX:1.09,scaleY:1.09,skewX:8,x:318.1,y:217.1},0).wait(2).to({regX:20.6,regY:5,scaleX:1.08,scaleY:1.1,skewX:8.8,x:318.5,y:218.3},0).wait(2).to({regX:20.5,regY:5.1,scaleX:1.08,scaleY:1.1,skewX:9.8,x:318.9,y:218.4},0).wait(2).to({regX:20.4,regY:5.4,scaleX:1.08,scaleY:1.1,skewX:10.5,x:319.3,y:218.7},0).wait(2).to({regX:19.9,scaleX:1.08,scaleY:1.11,skewX:11.5,x:320,y:218.5},0).wait(33));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(482.6,302.4,208.3,122.5);
// library properties:
lib.properties = {
	width: 600,
	height: 307,
	fps: 30,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/MWsloth_atlas_.png?1528313151596", id:"MWsloth_atlas_"},
		{src:"sounds/GleamAfterDrying5wav.mp3?1528313151854", id:"GleamAfterDrying5wav"}
	],
	preloads: []
};




})(lib_Sloth = lib_Sloth||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib_Sloth, images, createjs, ss, AdobeAn;